import loggingService from './loggingService'
import makeRequest from './contentfulService'

/**
 * @deprecated Any client-side calls should be converted to server-side calls in ./pages/api/musicapp/_services or
 * ported to ./client/index.ts if necessary
 */
const getAlbumArtwork = async (
	albumNumbers: number[]
): Promise<ContentfulAlbumArtwork[]> => {
	let response: Response
	try {
		response = await makeRequest(`
			albumCollection(where: { OR: [${albumNumbers.map((albumNumber) => {
				return `{ id: ${albumNumber} }`
			})} ]}) {
				items {
					id,
					artwork {
						url
					}
				}
			}
		`)

		if (!response.ok) {
			throw new Error(response.status.toString())
		}

		const result = await response.json()

		window?.newrelic?.log('Contentful client-side request', {
			level: 'info',
			customAttributes: {
				path: window.location.pathname,
				function: 'getAlbumArtwork',
			},
		})

		return result.data.albumCollection.items.map((item) => {
			return {
				albumNumber: item.id,
				url: item.artwork?.url ? `${item.artwork.url}?h=112&w=112` : null,
			}
		})
	} catch (error) {
		loggingService('Error retrieving album artwork', error, {
			errorType: 'Contentful',
			contentType: 'album artwork',
			contentId: albumNumbers.toString(),
			fetchUrl: response?.url,
			fetchStatus: response?.status,
		})
		return null
	}
}

export default getAlbumArtwork
